import { encode as base64_encode } from "base-64";
import MaterialIcon from "material-icons-react";
import React from "react";
import axios from "axios";
import { Navbar } from "react-materialize";
import { ConfigurarSas } from "../../components/GatewaySas/GatewaySas";
import KippLogo from "../../images/logo_kipp.svg";
import OmintLogo from "../../images/omint-logo.png";
import UserImage from "../../images/user-image.png";
import { inserirCookie, retornarCookie } from "../../services/cookieservice";
import "./NavigationBar.css";

const { REACT_APP_URL_INSTANCE, REACT_APP_SAS_URL, REACT_APP_API } =
  process.env;

export default class NavigationBar extends React.Component {
  state = {
    agenteVenda: undefined,
    retornoCadastroIregular: undefined
  };

  VerificarCadastroIrregular = async () => {
    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
    await axios
      .get(
        `${REACT_APP_API}agentevenda/VerificarCadastroIrregular?CdAgenteVendas=${retornarCookie(
          "CdAgenteVendas"
        )}&IdUsuario=${retornarCookie("IdUsuario")}`
      )
      .then((res) => {
        const retornoCadastroIregular = res.data;

        this.setState({ retornoCadastroIregular });
      });
  };

  async componentDidMount() {
    try {

      
      await this.VerificarCadastroIrregular();

      let CdAgenteVendas = retornarCookie("CdAgenteVendas");
      let Filial = retornarCookie("Filial");
      let IdAgenteVenda = retornarCookie("IdAgenteVenda");
      let DsAgenteVenda = retornarCookie("DsAgenteVenda");

      if (
        CdAgenteVendas === ""||
        Filial === "" ||
        IdAgenteVenda === "" ||
        DsAgenteVenda === ""
      ) {
        if (this.state.retornoCadastroIregular?.retorno === "NAO") {
          const sessionId = await ConfigurarSas();
          const agenteVenda = await this.retornarInformacoesAgenteVenda(
            sessionId,
            retornarCookie("CdAgenteVendas")
          );

          this.setState({ agenteVenda });
          inserirCookie("IdAgenteVenda", agenteVenda.id_AgenteVenda);
          inserirCookie("DsAgenteVenda", agenteVenda.ds_AgenteVenda);
          inserirCookie("Filial", agenteVenda.id_estfilial);
          this.setState({ exibeLogoTipoFilial: agenteVenda.id_estfilial });

          const Parametro = await this.VerificarParametroOdonto(sessionId);
          inserirCookie("PermiteOdonto", Parametro.value);
          window.location.reload();
        } else {
          const redirectTo = base64_encode("SemAcessoPage");

          document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
            retornarCookie("Auth")
          )}`;
        }
      } 
    } catch (error) {
    }
  }

  GoHomePage = () => {
    const redirectTo = base64_encode("NavigationBar,HomePage");

    document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
      retornarCookie("Auth")
    )}`;
  };

  VerificarParametroOdonto = async (sessionId) => {
    const headers = { "Content-Type": "application/json" };

    var body = JSON.stringify({
      SessionID: sessionId,
      screenIdentification: "SASGC0099",
      Parameters: [
        {
          parametername: "descricao",
          parametervalue: "CampoOdontologico",
        },
        {
          parametername: "id_filial",
          parametervalue: parseInt(retornarCookie("Filial")),
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers,
      body,
    };

    return await fetch(`${REACT_APP_SAS_URL}`, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        return result.responseJSONData.shift();
      });
  };

  retornarInformacoesAgenteVenda = async (sessionId, cdAgenteVenda) => {
    const headers = { "Content-Type": "application/json" };
    const body = JSON.stringify({
      SessionID: sessionId,
      screenIdentification: "SASGC0065",
      Parameters: [
        {
          parametername: "cd_agentevenda",
          parametervalue: cdAgenteVenda,
        },
        {
          parametername: "idFilial",
          parametervalue: retornarCookie("IdUsuario"),
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers,
      body,
    };

    return await fetch(`${REACT_APP_SAS_URL}`, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        return result.responseJSONData.shift();
      });
  };

  render() {
    return (
      <div>
        <Navbar
          alignLinks="left"
          brand={
            <div className="NavigationArea right fade-in">
              <b>
                {retornarCookie("CdAgenteVendas")}
                &nbsp;-&nbsp;
                {retornarCookie("DsAgenteVenda")}
              </b>
            </div>
          }
          id="mobile-nav"
          menuIcon={<MaterialIcon icon="menu" color="#172972" />}
          options={{
            draggable: true,
            edge: "left",
            inDuration: 250,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 200,
            preventScrolling: true,
          }}
        >
          {parseInt(retornarCookie("Filial")) === 3 && (
            <img
              className="logotipoKippNavbar fade-in "
              src={KippLogo}
              onClick={this.GoHomePage}
            />
          )}
          {parseInt(retornarCookie("Filial")) === 1 && (
            <img
              className="logotipoOmintNavbar fade-in "
              src={OmintLogo}
              onClick={this.GoHomePage}
            />
          )}
        </Navbar>
      </div>
    );
  }
}
